/* The Clay Arts: product page (fh-*). Ported from the reference product.js: photo gallery, variant and
   quantity, Add to cart and Buy now, plus the offer code copy button and the counting stats.
   Runs after fh-home.js (navbar, overlays, reveals, details accordion, window.FH_openCart).
   Written without backslashes on purpose. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------------------------------------------------
     Gallery: thumbnails, arrows, swipe (scroll-snap), keys
     --------------------------------------------------------- */
  var gallery = document.querySelector('.fh [data-gallery]');
  var goTo = function () {};
  if (gallery) {
    var track = gallery.querySelector('[data-track]');
    var slides = track.children;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
    var thumbList = thumbs.length ? thumbs[0].parentNode : null;
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.fh-pdp-dots span'));
    var prev = gallery.querySelector('[data-step="-1"]');
    var next = gallery.querySelector('[data-step="1"]');
    var status = gallery.querySelector('[data-gallery-status]');
    var current = 0;

    var mark = function (i, announce) {
      current = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-current', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-current', k === i); });
      prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
      next.setAttribute('aria-disabled', i >= slides.length - 1 ? 'true' : 'false');
      var t = thumbs[i];
      if (t && thumbList) {
        if (t.offsetTop < thumbList.scrollTop) thumbList.scrollTop = t.offsetTop;
        else if (t.offsetTop + t.offsetHeight > thumbList.scrollTop + thumbList.clientHeight) {
          thumbList.scrollTop = t.offsetTop + t.offsetHeight - thumbList.clientHeight;
        }
      }
      if (announce && status) status.textContent = 'Photo ' + (i + 1) + ' of ' + slides.length;
    };
    goTo = function (i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      mark(i, true);
    };

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    prev.addEventListener('click', function () { goTo(current - 1); });
    next.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(current + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    var scrollRaf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) mark(i, false);
      });
    }, { passive: true });
    window.addEventListener('resize', function () { track.scrollLeft = current * track.clientWidth; });
    mark(0, false);
  }

  /* ---------------------------------------------------------
     Variant and quantity: price, Add to cart and Buy now follow them
     --------------------------------------------------------- */
  var form = document.querySelector('.fh [data-fh-pdp-form]');
  if (form) {
    var add = form.querySelector('[data-fh-pdp-add]');
    var buy = form.querySelector('[data-buy-now]');
    var qty = form.querySelector('[data-qty]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');

    var money = function (paise) {
      return 'Rs. ' + (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    var selected = function () { return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][data-single]'); };
    var quantity = function () {
      var n = parseInt(qty.value, 10);
      return isNaN(n) ? 1 : Math.max(1, Math.min(99, n));
    };
    var sync = function (fromShopper) {
      var v = selected();
      if (!v) return;
      var n = quantity();
      var price = parseInt(v.getAttribute('data-price'), 10);
      var compare = parseInt(v.getAttribute('data-compare'), 10) || 0;
      var available = v.getAttribute('data-available') === 'true';
      priceEl.textContent = money(price);
      var bestEl = document.querySelector('[data-pdp-best]');
      if (bestEl) {
        var pct = parseInt(bestEl.getAttribute('data-pdp-best'), 10) || 0;
        bestEl.textContent = money(Math.round(price * (100 - pct) / 100));
      }
      compareEl.hidden = !(compare > price);
      compareEl.textContent = compare > price ? money(compare) : '';
      add.disabled = !available;
      add.textContent = available ? 'Add to cart' : 'Sold out';
      buy.hidden = !available;
      buy.href = root + 'cart/' + v.value + ':' + n;
      if (fromShopper && window.history.replaceState) {
        var params = new URLSearchParams(window.location.search);
        params.set('variant', v.value);
        window.history.replaceState(null, '', window.location.pathname + '?' + params.toString() + window.location.hash);
      }
    };

    form.addEventListener('change', function (e) {
      if (e.target.name === 'id') {
        sync(true);
        var img = parseInt(e.target.getAttribute('data-image'), 10);
        if (img >= 0) goTo(img);
      } else if (e.target === qty) {
        qty.value = quantity();
        sync();
      }
    });
    qty.addEventListener('input', function () { if (qty.value !== '') sync(); });
    qty.addEventListener('blur', function () { qty.value = quantity(); sync(); });
    Array.prototype.forEach.call(form.querySelectorAll('[data-qty-step]'), function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, Math.min(99, quantity() + parseInt(b.getAttribute('data-qty-step'), 10)));
        sync();
      });
    });

    // Add to cart through /cart/add.js, then the cart drawer (capture: no other script posts this form)
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var v = selected();
      if (!v || add.disabled || add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(v.value), quantity: quantity() }] })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          add.removeAttribute('aria-busy');
          if (!res.ok) {
            window.alert(res.data.description || res.data.message || 'Could not add to cart');
            return;
          }
          add.classList.add('is-added');
          add.textContent = 'Added';
          setTimeout(function () { add.classList.remove('is-added'); sync(); }, 1600);
          if (typeof window.FH_openCart === 'function') window.FH_openCart();
          else window.location.href = root + 'cart';
        })
        .catch(function () { add.removeAttribute('aria-busy'); form.submit(); });
    }, true);

    // Open on the variant in the address (?variant=ID)
    var wanted = new URLSearchParams(window.location.search).get('variant');
    var match = null;
    if (wanted) {
      Array.prototype.forEach.call(form.querySelectorAll('input[name="id"]'), function (i) { if (i.value === wanted && !i.disabled) match = i; });
    }
    if (match && match.type === 'radio') {
      match.checked = true;
      var start = parseInt(match.getAttribute('data-image'), 10);
      if (start >= 0) requestAnimationFrame(function () { goTo(start, true); });
    }
    sync();
  }

  /* ---------------------------------------------------------
     Offer code: tap to copy
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fh [data-fh-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-fh-copy');
    var hint = btn.querySelector('[data-fh-copy-hint]');
    var done = function () {
      btn.classList.add('is-copied');
      if (hint) hint.textContent = 'Copied';
      clearTimeout(btn.copyTimer);
      btn.copyTimer = setTimeout(function () { btn.classList.remove('is-copied'); if (hint) hint.textContent = btn.getAttribute('data-fh-copy-reset') || 'Tap to copy'; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
    } else { fallbackCopy(code); done(); }
  });
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (err) { /* nothing more to try */ }
    document.body.removeChild(ta);
  }

  /* ---------------------------------------------------------
     Stats: each number counts up the first time it scrolls into view
     --------------------------------------------------------- */
  var counters = Array.prototype.slice.call(document.querySelectorAll('.fh [data-count]'));
  if (counters.length && 'IntersectionObserver' in window && !reduceMotion) {
    counters.forEach(function (el) {
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
      el.textContent = '0';
    });
    var countObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countObserver.unobserve(entry.target);
        var el = entry.target;
        var end = parseInt(el.getAttribute('data-count'), 10) || 0;
        var start = null;
        var step = function (t) {
          if (start === null) start = t;
          var k = Math.min(1, (t - start) / 1600);
          el.textContent = String(Math.round(end * (1 - Math.pow(1 - k, 3))));
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { countObserver.observe(el); });
  }
})();
